import { render } from "./ListaAgendModal.vue?vue&type=template&id=283953b3&scoped=true"
import script from "./ListaAgendModal.vue?vue&type=script&lang=js"
export * from "./ListaAgendModal.vue?vue&type=script&lang=js"

import "./ListaAgendModal.vue?vue&type=style&index=0&id=283953b3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283953b3"]])

export default __exports__